import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";

// Same-origin: baseURL defaults to the current origin, and the client talks to
// the Worker's /api/auth/* endpoints (Better Auth's default basePath).
export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

export const { useSession, signIn, signOut } = authClient;
